import PropTypes from 'prop-types'
import React from 'react'
import * as Yup from 'yup'

import {
  Form,
  FormikDialog,
  FormikTextField,
  FIELD_REQUIRED,
  SupplierField,
} from 'src/modules/ui'

import { useMessages } from 'src/modules/messages'

const MessageBuyerModal = ({
  environmentId,
  buyer,
  subject = '',
  ...props
}) => {
  const { sendMessage } = useMessages()

  const handleSubmit = ({ subject, message }) =>
    sendMessage({
      buyerId: buyer.id,
      subject,
      text: message,
      environmentId,
    })

  const initialValues = {
    subject,
    message: '',
  }

  const validationSchema = Yup.object().shape({
    subject: Yup.string().required(FIELD_REQUIRED),
    message: Yup.string().required(FIELD_REQUIRED),
  })

  return (
    <FormikDialog
      initialValues={initialValues}
      onSubmit={handleSubmit}
      submitText="Send Message"
      successNotification="Message sent to buyer"
      title="Contact Buyer"
      validationSchema={validationSchema}
      {...props}
    >
      <Form>
        <SupplierField label="To" supplier={buyer} />
        <FormikTextField
          autoFocus={subject === ''}
          fullWidth
          label="Subject"
          margin="normal"
          name="subject"
          type="text"
        />
        <FormikTextField
          autoFocus={subject !== ''}
          fullWidth
          label="Message"
          name="message"
          margin="normal"
          multiline
          minRows={10}
          type="text"
        />
      </Form>
    </FormikDialog>
  )
}

MessageBuyerModal.propTypes = {
  buyer: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  subject: PropTypes.string,
  trigger: PropTypes.func,
}

MessageBuyerModal.defaultProps = {
  environmentId: '',
}

export default MessageBuyerModal
